// src/components/FreshdeskWidget.tsx
import { useEffect } from "react";
import { FRESHDESK_WIDGET_ID, FRESHDESK_WIDGET_URL } from "../../apiConfig";
import { StoreService } from "../../services/store/applicationStateService";

export default function FreshdeskHelp() {
  useEffect(() => {
    // Prevent loading the script multiple times

    if (document.getElementById("freshdesk-widget-script")) return;

    if (!StoreService.getStorage("jwtToken"))
      return document.getElementById("freshdesk-widget-script")?.remove();

    // Ensure global settings exist before script runs
    (window as any).fwSettings = {
      widget_id: FRESHDESK_WIDGET_ID,
    };

    // Create script tag
    const script = document.createElement("script");
    script.id = "freshdesk-widget-script";
    script.src = `${FRESHDESK_WIDGET_URL.replace(
      "${REACT_APP_FRESHDESK_WIDGET_ID}",
      FRESHDESK_WIDGET_ID
    )}`;
    script.async = true;
    script.defer = true;

    // Append to body
    document.body.appendChild(script);

    return () => {
      // Optional: if you ever need to completely remove the widget
      // document.getElementById("freshdesk-widget-script")?.remove();
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const widgetFrame =
        document.querySelector("iframe[id^='launcher']") ||
        document.querySelector("div[id^='launcher']");

      if (widgetFrame && !widgetFrame.contains(e.target as Node)) {
        (window as any).FreshworksWidget?.("close");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return null; // This component doesn't render UI
}
